import styled from 'styled-components';

export const FlexStyled = styled.div`
  display: flex;
  ${({ paddingSize }) => {
    switch (paddingSize) {
      case 'small':
        return 'padding: 16px;';
      case 'medium':
        return 'padding: 24px;';
    }
  }}
  ${({ column }) => column && 'flex-direction: column;'}
  ${({ fillArea }) => fillArea && 'width: 100%;'}
  ${({ fillHeight }) => fillHeight && 'height: 100%;'}
  ${({ spaceBetween }) => spaceBetween && 'justify-content: space-beteween;'}
  ${({ justifyCenter }) => justifyCenter && 'justify-content: center;'}
  ${({ justifyEnd }) => justifyEnd && 'justify-content: flex-end;'}
  ${({ alignCenter }) => alignCenter && 'align-items: center;'}
  ${({ alignEnd }) => alignEnd && 'align-items: flex-end;'}
`;
